import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
var VALUES_REG = /,(?![^(]*\))/;
var PARTS_REG = /\s(?![^(]*\))/;
var LENGTH_REG = /^[0-9]+[a-zA-Z%]+?$/;
var parseValue = function(str) {
    var parts = str.split(PARTS_REG);
    var inset = parts.includes("inset");
    var last = parts.slice(-1)[0];
    var color = !isLength(last) ? last : undefined;
    var nums = parts.filter(function(n) {
        return n !== "inset";
    }).filter(function(n) {
        return n !== color;
    }).map(toNum);
    var _nums = _sliced_to_array(nums, 4), offsetX = _nums[0], offsetY = _nums[1], blurRadius = _nums[2], spreadRadius = _nums[3];
    return {
        inset: inset,
        offsetX: offsetX,
        offsetY: offsetY,
        blurRadius: blurRadius,
        spreadRadius: spreadRadius,
        color: color
    };
};
var stringifyValue = function(obj, multipler) {
    var ref = obj || {}, inset = ref.inset, _offsetX = ref.offsetX, offsetX = _offsetX === void 0 ? 0 : _offsetX, _offsetY = ref.offsetY, offsetY = _offsetY === void 0 ? 0 : _offsetY, _blurRadius = ref.blurRadius, blurRadius = _blurRadius === void 0 ? 0 : _blurRadius, spreadRadius = ref.spreadRadius, color = ref.color;
    return [
        inset ? "inset" : null,
        offsetX,
        offsetY,
        blurRadius,
        spreadRadius,
        color
    ].filter(function(v) {
        return v !== null && v !== undefined;
    }).map(function(s) {
        return toVw(s, multipler);
    }).map(function(s) {
        return ("" + s).trim();
    }).join(" ");
};
var isLength = function(v) {
    return v === "0" || LENGTH_REG.test(v);
};
var toNum = function(v) {
    if (isNaN(+v)) return v;
    var n = parseFloat(v);
    return !isNaN(n) ? n : v;
};
var toVw = function(n, multipler) {
    return typeof n === "number" && n !== 0 ? multipler(n) : n;
};
export var parse = function(str) {
    return str.split(VALUES_REG).map(function(s) {
        return s.trim();
    }).map(parseValue);
};
export var stringify = function(arr, multipler) {
    return arr.map(function(v) {
        return stringifyValue(v, multipler);
    }).join(", ");
};
export var isFluid = function(str) {
    return !!parse(str).find(function(s) {
        var ref = s || {}, _offsetX = ref.offsetX, offsetX = _offsetX === void 0 ? 0 : _offsetX, _offsetY = ref.offsetY, offsetY = _offsetY === void 0 ? 0 : _offsetY, _blurRadius = ref.blurRadius, blurRadius = _blurRadius === void 0 ? 0 : _blurRadius, spreadRadius = ref.spreadRadius;
        return [
            offsetX,
            offsetY,
            blurRadius,
            spreadRadius
        ].find(function(v) {
            return typeof v === "number" && v !== 0;
        });
    });
};
